module.exports = __webpack_public_path__ + "media/images/badge/hero-member-42bbdee7af52c1a023b2910b829e5ed2.png";